{
  "slabTableConfig": [
    {
      "label": "id",
      "displayLabel": "ID",
      "placeholder": "Enter Id",
      "hidden": true,
      "editable": false
    },
    {
      "label": "from",
      "displayLabel": "From",
      "placeholder": "Enter From",
      "editable": true,
      "fieldInfo": {
        "dataType": "number"
      }
    },
    {
      "label": "to",
      "displayLabel": "To",
      "placeholder": "Enter To",
      "editable": true,
      "fieldInfo": {
        "dataType": "number"
      }
    },
    {
      "label": "chargePerPeriod",
      "displayLabel": "Charge per Period",
      "placeholder": "Enter Charge Per Period",
      "editable": true,
      "fieldInfo": {
        "dataType": "number"
      }
    },
    {
      "label": "tariffExpression",
      "displayLabel": "Amount (Per Period)",
      "placeholder": "Enter Amount",
      "editable": true,
      "fieldInfo": {
        "defaultValue": 0,
        "dataType": "text"
      }
    },
    {
      "label": "minTariffExpression",
      "displayLabel": "Min. Amount",
      "placeholder": "Enter Min. Amount",
      "editable": true,
      "fieldInfo": {
        "defaultValue": 0,
        "dataType": "text"
      }
    }
  ]
}
